import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getMenusDetails = createAsyncThunk(
  "menus/getMenudetails",
  async (canteen_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://headquater.pixoatic.com/api/v1/menus?canteen_id=${canteen_id}`
      );
      return response.data;
    } catch (errors) {
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

const menuSlice = createSlice({
  name: "menus",
  initialState: {
    loading: false,
    error: null,
    menu: {
      categories: [],
      combo_offer_categories: [],
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMenusDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMenusDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.menu = action.payload.dashboard;
      })
      .addCase(getMenusDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default menuSlice.reducer;
